module.exports = __webpack_public_path__ + "static/media/small-profile.d7a1c869.png";